export const SHOW_ALERT = 'SHOW_ALERT';
